import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  isPosting: false,
  feedbacks: [],
  currentFeedback: null,
  error: null,
};

export const feedbackSlice = createSlice({
  name: "feedback",
  initialState,
  reducers: {
    getFeedbackStart: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },
    getFeedbackSuccess: (state, action) => {
      state.isLoading = false;
      state.feedbacks = action.payload;
      state.error = null;
    },
    getFeedbackFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    setCurrentfeedback: (state, action) => {
      state.currentFeedback = action.payload;
    },
    postFeedbackStart: (state, action) => {
      state.isPosting = true;
      state.error = null;
    },
    postFeedbackSuccess: (state, action) => {
      state.isPosting = false;
    },
    postFeedbackFailure: (state, action) => {
      state.isPosting = false;
      state.error = action.payload;
    },
  },
});

export const {
  getFeedbackFailure,
  getFeedbackStart,
  getFeedbackSuccess,
  postFeedbackFailure,
  postFeedbackStart,
  postFeedbackSuccess,
  setCurrentfeedback,
} = feedbackSlice.actions;

const feedbackReducer = feedbackSlice.reducer;
export default feedbackReducer;
